export default {
  TableHead: [
    [
      {
        displayName: 'betcancel.datatable.number',
      },
      {
        displayName: 'betcancel.datatable.ticketid',
      },
      {
        displayName: 'betcancel.datatable.requestresponse',
      },
      {
        displayName: 'betcancel.datatable.retry',
      },
    ],
  ],
};
